













































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import * as utils_topshot from '@/utils_topshot';
import { Player } from '@/Player'
import { SimpleSet } from '@/SimpleSet'
import { SimpleDuo } from '@/SimpleDuo'
import { AdvancedSearch } from '@/Moment'

@Component({
  name: 'MomentSelectorAndSorter',
  components: {}
})
export default class MomentSelectorAndSorterComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public startingSortOrders: Array<{ label: string, sort: string }>

  @Prop({ default: false })
  public useFullWidth: boolean;

  @Prop({ default: false })
  public noSelector: boolean;

  @Prop({ default: false })
  public noAdvanced: boolean;

  @Prop({ default: false })
  public playerSelectorOnly: boolean;

  @Prop({ default: false })
  public setSelectorOnly: boolean;

  @Prop({ default: false })
  public noSorter: boolean;

  @Prop({ default: true })
  public showLeague: boolean;  

  @Prop({ default: true })
  public showTeam: boolean;  

  @Prop({ default: true })
  public showRarity: boolean;  

  @Prop({ default: true })
  public showPlay: boolean;  

  @Prop({ default: true })
  public showPriceRange: boolean;  

  @Prop({ default: true })
  public showFMVRange: boolean;  

  @Prop({ default: true })
  public showSerialRange: boolean;  

  @Prop({ default: true })
  public showMinDiscount: boolean;  

  @Prop({ default: true })
  public showCheckboxes: boolean;  

  @Prop({ default: false })
  public showLockedCheckbox: boolean;  

  @Prop({ default: 'All Players' })
  public allPlayersString: string;

  @Prop({ default: 'All Sets' })
  public allSetsString: string;

  @Prop({ default: 'All Moments' })
  public allMomentsString: string;

  @Prop({ default: true })
  public showSeries: boolean;  

  // public reactive member variables available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get userId(): string { return this.$store.getters.userId }

  // UI and filter options
  public player: { label: string, playerID: number } = null
  public players: Array<{ label: string, playerID: number }> = []
  public set: { label: string, setID: number } = null
  public sets: Array<{ label: string, setID: number }> = []
  public duo: { label: string, setID: number, playID: number } = null
  public duos: Array<{ label: string, setID: number, playID: number }> = [ ]
  public sortOrder: { label: string, sort: string } = null
  public sortOrders: Array<{ label: string, sort: string }> = []

  // advanced search stuff
  public showAdvanced: boolean = false
  public advancedSearchStringUsed: string = null

  public teams: string[] = [
    'All Teams',
    'Atlanta Hawks', 'Boston Celtics', 'Brooklyn Nets', 'Charlotte Hornets',
    'Chicago Bulls', 'Cleveland Cavaliers', 'Dallas Mavericks', 'Denver Nuggets',
    'Detroit Pistons', 'Golden State Warriors', 'Houston Rockets', 'Indiana Pacers',
    'LA Clippers', 'Los Angeles Lakers', 'Memphis Grizzlies', 'Miami Heat',
    'Milwaukee Bucks', 'Minnesota Timberwolves', 'New Orleans Pelicans', 'New York Knicks',
    'Oklahoma City Thunder', 'Orlando Magic', 'Philadelphia 76ers', 'Phoenix Suns',
    'Portland Trail Blazers', 'Sacramento Kings', 'San Antonio Spurs', 'Toronto Raptors',
    'Utah Jazz', 'Washington Wizards',
    'Team Durant', 'Team LeBron',
    'Atlanta Dream', 'Chicago Sky', 'Connecticut Sun', 'Dallas Wings', /* 'Detroit Shock', */ 'Houston Comets', 'Indiana Fever', 'Las Vegas Aces',
    'Los Angeles Sparks', 'Minnesota Lynx', 'New York Liberty', 'Phoenix Mercury', 'Sacramento Monarchs', /* 'San Antonio Silver Stars', */ 'Seattle Storm', 'Washington Mystics'
  ]  

  public team: string = this.teams[0]
  public minPrice: string = null
  public maxPrice: string = null
  public minFMV: string = null
  public maxFMV: string = null
  public minSerial: string = null
  public maxSerial: string = null
  public minDiscount: string = null
  public jersey: boolean = false
  public lastMint: boolean = false
  public neverSold: boolean = false
  public locked: boolean = false
  public notlocked: boolean = false
  public tsdebut: boolean = false
  public rookieYear: boolean = false
  public rookieMint: boolean = false
  public rookiePremiere: boolean = false
  public champYear: boolean = false
  public challengeReward: boolean = false
  public craftingChallengeReward: boolean = false

  public leagues: Array<string> = [
    'League',
    'NBA',
    'WNBA'
  ]
  public league: string = this.leagues[0]

  public playCategories: Array<string> = [
    'All Play Categories',
    '3 Pointer',
    'Assist',
    'Block',
    'Dunk',
    'Handles',
    'Hook Shot',
    'Jump Shot',
    'Layup',
    'Redemption',
    'Reel',
    'Steal',
  ]
  public playCategory: string = this.playCategories[0]

  public rarities: Array<string> = [
    'All Rarities', 'Common', 'Fandom', 'Rare', 'Legendary', 'Ultimate'
  ]
  public rarity: string = this.rarities[0]

  public seriesChoices: Array<string> = [ 'All Series' ].concat(utils_topshot.getSeriesArray())
  public series: string = this.seriesChoices[0]

  public async onClear() {
    this.league = this.leagues[0]
    this.team = this.teams[0]
    this.rarity = this.rarities[0]
    this.playCategory = this.playCategories[0]
    this.minPrice = null
    this.maxPrice = null
    this.minFMV = null
    this.maxFMV = null
    this.minSerial = null
    this.maxSerial = null
    this.minDiscount = null
    this.jersey = false
    this.lastMint = false
    this.neverSold = false
    this.locked = false
    this.notlocked = false
    this.tsdebut = false
    this.rookieYear = false
    this.rookieMint = false
    this.rookiePremiere = false
    this.champYear = false
    this.challengeReward = false
    this.craftingChallengeReward = false
    this.series = this.seriesChoices[0]

    const promises: Array<Promise<any>> = []

    this.player = { label: this.allPlayersString, playerID: 0 }
    this.set = { label: this.allSetsString, setID: 0 }
    this.duo = { label: this.allMomentsString, setID: 0, playID: 0 }

    this.$emit('changed-advanced', this.createAdvancedSearch())

    await Promise.all(promises)
  }

  public clickedAdvanced() {
    this.showAdvanced = !this.showAdvanced
  }

  public onHide() {
    this.showAdvanced = false
  }

  public async onSearch() {
    this.$emit('changed-advanced', this.createAdvancedSearch())
  }

  public createAdvancedSearch(): AdvancedSearch {
    const advancedSearch: AdvancedSearch = {}

    // cleanup
    if (this.minPrice) this.minPrice = this.minPrice.replace(/\D/g, "");
    if (this.maxPrice) this.maxPrice = this.maxPrice.replace(/\D/g, "");
    if (this.minFMV) this.minFMV = this.minFMV.replace(/\D/g, "");
    if (this.maxFMV) this.maxFMV = this.maxFMV.replace(/\D/g, "");
    if (this.minSerial) this.minSerial = this.minSerial.replace(/\D/g, "");
    if (this.maxSerial) this.maxSerial = this.maxSerial.replace(/\D/g, "");
    if (this.minDiscount) this.minDiscount = this.minDiscount.replace(/\D/g, "");

    // assign
    if (this.series !== 'All Series') advancedSearch.series = utils_topshot.getSeriesNumber(this.series)    // May 16, 2024
    if (this.league !== 'League') advancedSearch.league = this.league
    if (this.team !== 'All Teams') advancedSearch.team = this.team
    if (this.rarity !== 'All Rarities') advancedSearch.rarity = this.rarity
    if (this.playCategory !== 'All Play Categories') advancedSearch.playCategory = this.playCategory

    if (Number(this.minPrice) > 0) advancedSearch.minPrice = Number(this.minPrice)
    if (Number(this.maxPrice) > 0) advancedSearch.maxPrice = Number(this.maxPrice)
    if (Number(this.minFMV) > 0) advancedSearch.minFMV = Number(this.minFMV)
    if (Number(this.maxFMV) > 0) advancedSearch.maxFMV = Number(this.maxFMV)
    if (Number(this.minSerial) > 0) advancedSearch.minSerial = Number(this.minSerial)
    if (Number(this.maxSerial) > 0) advancedSearch.maxSerial = Number(this.maxSerial)
    if (Number(this.minDiscount) > 0) advancedSearch.minDiscount = Number(this.minDiscount)

    // heuristics - so we allow .15 or 15
    if (advancedSearch.minDiscount && advancedSearch.minDiscount >= 1) advancedSearch.minDiscount /= 100

    if (this.jersey) advancedSearch.jersey = this.jersey
    if (this.lastMint) advancedSearch.lastMint = this.lastMint
    if (this.neverSold) advancedSearch.neverSold = this.neverSold
    if (this.locked) advancedSearch.locked = this.locked
    if (this.notlocked) advancedSearch.notlocked = this.notlocked
    if (this.tsdebut) advancedSearch.tsdebut = this.tsdebut
    if (this.rookieYear) advancedSearch.rookieYear = this.rookieYear
    if (this.rookieMint) advancedSearch.rookieMint = this.rookieMint
    if (this.rookiePremiere) advancedSearch.rookiePremiere = this.rookiePremiere
    if (this.champYear) advancedSearch.champYear = this.champYear
    if (this.challengeReward) advancedSearch.challengeReward = this.challengeReward
    if (this.craftingChallengeReward) advancedSearch.craftingChallengeReward = this.craftingChallengeReward

    // check for null
    if (advancedSearch.league || advancedSearch.team|| advancedSearch.rarity || advancedSearch.playCategory || advancedSearch.minPrice || advancedSearch.maxPrice || advancedSearch.minFMV || advancedSearch.maxFMV || advancedSearch.minSerial || advancedSearch.maxSerial || advancedSearch.minDiscount ||
        advancedSearch.jersey || advancedSearch.lastMint || advancedSearch.neverSold || advancedSearch.locked || advancedSearch.notlocked || 
        advancedSearch.tsdebut || advancedSearch.rookieYear || advancedSearch.rookieMint || advancedSearch.rookiePremiere || advancedSearch.champYear || advancedSearch.challengeReward || advancedSearch.craftingChallengeReward || (advancedSearch.series !== null && advancedSearch.series !== undefined)) return advancedSearch

    return null
  }



  // @ts-ignore
  public selectedOptionValue: string = this.startingSelectedOptionValue

  // public functions available to the html template

  // events from user action
  public async onChangedPlayer(player: { label: string, playerID: number }) {
    this.player = player ? player : { label: this.allPlayersString, playerID: 0 }
    this.$emit('changed-psd', this.player, this.set, this.duo)
    await this.fetchData()
  }
  public async onChangedSet(set: { label: string, setID: number }) {
    this.set = set ? set : { label: this.allSetsString, setID: 0 }
    this.$emit('changed-psd', this.player, this.set, this.duo)
    await this.fetchData()
  }
  public async onChangedDuo(duo: { label: string, setID: number, playID: number }) {
    this.duo = duo ? duo : { label: this.allMomentsString, setID: 0, playID: 0 }
    this.$emit('changed-psd', this.player, this.set, this.duo)
    await this.fetchData()
  }
  public onChangedSort(sortOrder: { label: string, sort: string }) {
    this.sortOrder = sortOrder ? sortOrder : this.sortOrders[0]
    this.$emit('changed-sort', this.sortOrder)
  }

  // events send in from parent
  public async notifyChangedPlayerIDFromParent(playerID: number) {
    this.player = null
    for (const player of this.players) if (player.playerID === playerID) this.player = player
    if (!this.player) this.player = { label: '', playerID }            // we'll set this more properly in fetchData
    if (!playerID) this.player = { label: this.allPlayersString, playerID: 0 }
    await this.fetchData()
  }
  public async notifyChangedSetIDFromParent(setID: number) {
    this.set = null
    for (const set of this.sets) if (set.setID === setID) this.set = set
    if (!this.set) this.set = { label: '', setID }            // we'll set this more properly in fetchData
    if (!setID) this.set = { label: this.allSetsString, setID: 0 }
    await this.fetchData()
  }
  public async notifyChangedPlayerIDAndSetIDAndPlayIDFromParent(playerID: number, setID: number, playID: number) {
    this.player = null
    for (const player of this.players) if (player.playerID === playerID) this.player = player
    if (!this.player) this.player = { label: '', playerID }            // we'll set this more properly in fetchData
    if (!playerID) this.player = { label: this.allPlayersString, playerID: 0 }
    this.duo = null
    for (const duo of this.duos) if (duo.setID === setID && duo.playID === playID) this.duo = duo
    if (!this.duo) this.duo = { label: '', setID, playID }    // we'll set this more properly in fetchData
    if (!playID) this.duo = { label: this.allMomentsString, setID: 0, playID: 0 }
    await this.fetchData()
  }
  public notifyChangedSortFromParent(sort: string) {
    for (const so of this.sortOrders) if (so.sort === sort) this.sortOrder = so
  }
  public notifyChangedSortOrdersFromParent(sortOrders: Array<{ label: string, sort: string }>) {
    this.sortOrders = sortOrders
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private lastFetchedURL: string = null
  private localLoading: boolean = false

  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    this.player = { label: this.allPlayersString, playerID: 0 }
    this.set = { label: this.allSetsString, setID: 0 }
    this.duo = { label: this.allMomentsString, setID: 0, playID: 0 }

    if (this.startingSortOrders) {
      this.sortOrders = this.startingSortOrders
      this.sortOrder = this.sortOrders[0]
    }
    
    await this.fetchData()
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }


  // the reason for pageNumberWhenCalled is for race-condition prevention
  private async fetchData(): Promise<void> {
    let url: string = utils.getURLprefix() + `/api/topshot/momentSelector/?`;
    if (this.player && this.player.playerID) url += `&playerID=${this.player.playerID}`
    if (this.duo && this.duo.setID) url += `&setID=${this.duo.setID}&playID=${this.duo.playID}`
    else if (this.set && this.set.setID) url += `&setID=${this.set.setID}`
    const commonCase: boolean = url.endsWith('?')

    // don't fetch if we're in the middle of fetching same url
    if (this.localLoading) {
      if (this.lastFetchedURL === url) {
        if (this.$store.state.devmode) console.log(`MomentSelectorAndSorterComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.localLoading = true
    // this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      let responseData: any
      if (commonCase) responseData = utils_topshot.getMomentSelectorResponseData()

      if (!responseData) {
        // console.log(url)
        const response: any = await utils.makeGetCall(url);

        // whoa, we got another call after this one, so let's abort this one
        if (this.lastFetchedURL !== url) return

        // error check
        if (response.data.error) {
          utils.toast(this, 'Error', response.data.error)
          this.localLoading = false
          // this.$store.commit('setLoading', { loading: false });
          return
        }

        responseData = response.data

        // for performance reasons, let's save response.data in a cache for the most common case
        if (commonCase) utils_topshot.setMomentSelectorResponseData(responseData)
      }

      // load up the players, simpleSets and simpleDuos from the server
      const players: Player[] = responseData.players
      if (players) {
        this.players = [ { label: this.allPlayersString, playerID: 0 } ]
        for (const player of players) {
          this.players.push({ label: player.name, playerID: player.playerID });
        }
        if (this.player.playerID === 0) this.player = this.players[0]
        if (this.player.label === '') for (const player of this.players) if (player.playerID === this.player.playerID) this.player = player                                        // fix set now that we have the label
      }
      const simpleSets: SimpleSet[] = responseData.simpleSets
      if (simpleSets) {
        this.sets = [ { label: this.allSetsString, setID: 0 } ]
        for (const simpleSet of simpleSets) {
          simpleSet.name = simpleSet.name.replace('Conference', 'Conf')
          simpleSet.name = simpleSet.name.replace('Hometown Showdown', 'Home SD')
          simpleSet.name = simpleSet.name.replace('And Then There Were Four', 'Then There Were 4')
          simpleSet.name = simpleSet.name.replace('Run It Back: Legacies 1986-87', 'RIB: Legacies 1986-87')
          simpleSet.name = simpleSet.name.replace('WNBA Game Recognize Game', 'WNBA GRG')
          simpleSet.name = simpleSet.name.replace('The Anthology: Magic Johnson', 'The Anthology: Magic J')

          // Feb 26, 2024: ok not really an abbreviation, but a fix for stupid Dapper mistake
          simpleSet.name = simpleSet.name.replace('Base Set6', 'Base Set')
          simpleSet.name = simpleSet.name.replace('Rookie Debut6', 'Rookie Debut')
          simpleSet.name = simpleSet.name.replace('Throwdowns6', 'Throwdowns')

          // May 8, 2024
          simpleSet.name = simpleSet.name.replace("The Champion's Path 2024", "Champion's Path 2024")

          this.sets.push({ label: simpleSet.name, setID: simpleSet.setID });
        }
        if (this.set.setID === 0) this.set = this.sets[0]
        if (this.set.label === '') for (const set of this.sets) if (set.setID === this.set.setID) this.set = set                                        // fix set now that we have the label
      }
      const simpleDuos: SimpleDuo[] = responseData.simpleDuos
      if (simpleDuos) {
        this.duos = [ { label: this.allMomentsString, setID: 0, playID: 0 } ]
        for (const simpleDuo of simpleDuos) {
          simpleDuo.name = simpleDuo.name.replace('Conference', 'Conf')
          simpleDuo.name = simpleDuo.name.replace('Hometown Showdown', 'Home SD')
          simpleDuo.name = simpleDuo.name.replace('And Then There Were Four', 'Then There Were 4')
          simpleDuo.name = simpleDuo.name.replace('Run It Back: Legacies 1986-87', 'RIB: Legacies 1986-87')
          simpleDuo.name = simpleDuo.name.replace('WNBA Game Recognize Game', 'WNBA GRG')
          simpleDuo.name = simpleDuo.name.replace('The Anthology: Magic Johnson', 'The Anthology: Magic J')

          // Feb 26, 2024: ok not really an abbreviation, but a fix for stupid Dapper mistake
          simpleDuo.name = simpleDuo.name.replace('Base Set6', 'Base Set')
          simpleDuo.name = simpleDuo.name.replace('Rookie Debut6', 'Rookie Debut')
          simpleDuo.name = simpleDuo.name.replace('Throwdowns6', 'Throwdowns')

          // May 8, 2024
          simpleDuo.name = simpleDuo.name.replace("The Champion's Path 2024", "Champion's Path 2024")

          this.duos.push({ label: simpleDuo.name, setID: simpleDuo.setID, playID: simpleDuo.playID });
        }
        if (this.duo.setID === 0 && this.duo.playID === 0) this.duo = this.duos[0]
        if (this.duo.label === '') for (const duo of this.duos) if (duo.setID === this.duo.setID && duo.playID === this.duo.playID) this.duo = duo      // fix duo now that we have the label
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return
    } finally {
      this.localLoading = false
      // this.$store.commit('setLoading', { loading: false });
    }
  }

}
